import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { BrowserRouter as Router, HashRouter, Route, Prompt } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import HomePage from "../pages/HomePage";
import GenericPage from "./generic/GenericPage";
import TopMenu from "../TopMenu";
import BottomBar from "../BottomBar";
import { getVisibleAlert } from "../../../reducers/generic/notifications";

import FuseToast, { ToastTypes } from "../modals/FuseToast";
import LoadingSpinnerOverlay from "../LoadingSpinnerOverlay";
import { hideToastAction } from "../../../actions/generic/toastActions";
import RolesPage from "./roles/RolesPage";
import HomeDashboardPage from "./HomeDashboardPage";
import ProfilePage from "./profile/ProfilePage";

class MainApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      exit: true
    };
  }

  static defaultProps = {};

  componentDidMount() {}

  onItemSelectionChanged = (rowId) => {};

  hideRouteConfirmAlert(status) {
    if (status) {
      this.setState({
        alert: null,
        exit: false
      });
    } else {
      this.setState({
        alert: null,
        exit: true
      });
    }
  }

  routeConfirmAlert = (title, message, callback) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          showCancel
          title={title}
          onConfirm={() => {
            this.hideRouteConfirmAlert(true);
            callback(true);
          }}
          onCancel={() => {
            this.hideRouteConfirmAlert(false);
            callback(false);
            window.history.back();
          }}
        >
          {message}
        </SweetAlert>
      )
    });
  };

  onToastClosed = (toastInfo) => {
    this.props.hideToastAction(toastInfo.id);
  };

  renderLoading = () => {
    return <LoadingSpinnerOverlay className="d-flex justify-content-center " />;
  };

  render() {
    const { visibleAlert } = this.props;

    return (
      <Row className="lg">
        <Col className="position-relative">
          {visibleAlert && <SweetAlert {...visibleAlert}>{visibleAlert.content}</SweetAlert>}
          <div className="toast-container position-fixed p-3 zindex-modal-backdrop mb-5" style={{ zIndex: 9999, bottom: 0, right: 0 }}>
            {this.props.toastList.map((toastInfo) => (
              <FuseToast
                key={toastInfo.id}
                onClose={() => this.onToastClosed(toastInfo)}
                isShowing={toastInfo.isShowing}
                type={toastInfo.type}
                title={toastInfo.title}
                text={toastInfo.text}
                delay={toastInfo.delay}
                autohide={true}
              />
            ))}
          </div>

          {this.state.alert}
          <HashRouter
            getUserConfirmation={(payload, callback) => {
              const { title, message } = JSON.parse(payload);
              this.routeConfirmAlert(title, message, callback);
            }}
          >
            {/* Loading indicator for when the generic page loads with panels */}
            {this.props.fetchingData && this.renderLoading()}
            <Prompt
              when={this.props.scopeIsDirty}
              message={JSON.stringify({
                title: "Unsaved changes!",
                message: "This will lose your changes. Are you sure want leave the page?"
              })}
            />
            <TopMenu />
            <Container fluid>
              {/* <Route path="/" exact component={HomePage} /> */}
              <Route path="/" exact component={HomeDashboardPage} />
              <Route exact path="/generic" component={GenericPage} />              
              <Route exaxt path="/roles" component={RolesPage}/>              
              <Route exaxt path="/profile" component={ProfilePage}/>
            </Container>
            <BottomBar />
          </HashRouter>
        </Col>
      </Row>
    );
  }
}

MainApp.propTypes = {
  visibleAlert: PropTypes.any,
  fetchingData: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    fetchingData: state.fetchingData === true,
    visibleAlert: getVisibleAlert(state.notifications),
    scopeIsDirty: state.scope.isDirty,
    toastList: state.toastList
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    hideToastAction: (id) => dispatch(hideToastAction(id))
  })
)(MainApp);
